const routes = [
  {name: 'login',         path: '/ui/switches(/)'},
  {name: 'main',          path: '/ui/switches/main(/)'}
];

export default routes;
